export var SearchType;
(function (SearchType) {
    SearchType[SearchType["Query"] = 1] = "Query";
    SearchType[SearchType["Similarity"] = 2] = "Similarity";
    SearchType[SearchType["Regex"] = 3] = "Regex";
    SearchType[SearchType["Exact"] = 1] = "Exact";
    SearchType[SearchType["Similar"] = 2] = "Similar";
})(SearchType || (SearchType = {}));
//# sourceMappingURL=phrase-triggers.js.map